// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bhya","newExpiryDate":"styles_newExpiryDate__230qD","footer":"styles_footer__UQ520"};